export default {
  noDataRow: {
    textAlign: 'center',
    color: 'lightgrey',
    fontSize: 24,
  },
  noData: {
    fontSize: 250,
    color: 'lightgrey',
  },
  taskStageCol: {
    width: 80,
  },
  actionCol: {
    width: 170,
    // textAlign: 'right',
  },
  stageIcon: {
    width: 28,
    height: 28,
  },
  stageNotStarted: {
    color: 'red',
  },
  stagePending: {
    color: 'blue',
  },
  stageComplete: {
    color: 'green',
  },
};



// WEBPACK FOOTER //
// ./src/components/TasksTable/styles.js